module.exports = __webpack_public_path__ + "static/media/country_bo.1c042571.webp";